








































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

import * as def from "@/definitions";

import { CalendarLayer } from "@/model/document2/page/surface/design/layer/calendarLayer";
import { ColorConstruct } from "@/utilityModels/colorConstruct";
import { FontManager } from '@/model/fontManager/fontManager';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import FontSelector from "@/commonComponents/fontSelector/fontSelector.vue";
import AdjustedBalloon from "@/commonComponents/adjustedBalloon/adjustedBalloon.vue"

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";
import RadioOn from "../resources/radioOn.vue";
import AlignLeftOn from "../resources/alignLeft_on.vue";
import AlignLeftOff from "../resources/alignLeft_off.vue";
import AlignCenterOn from "../resources/alignCenter_on.vue";
import AlignCenterOff from "../resources/alignCenter_off.vue";
import AlignRightOn from "../resources/alignRight_on.vue";
import AlignRightOff from "../resources/alignRight_off.vue";
import AlignTopOn from "../resources/alignTop_on.vue";
import AlignTopOff from "../resources/alignTop_off.vue";
import AlignMiddleOn from "../resources/alignMiddle_on.vue";
import AlignMiddleOff from "../resources/alignMiddle_off.vue";
import AlignBottomOn from "../resources/alignBottom_on.vue";
import AlignBottomOff from "../resources/alignBottom_off.vue";

import { DebugHelper } from "@/helper/debugHelper"
import { ResourceHelper } from "@/helper/resourceHelper"


@Component({
  components: {
    ColorPicker,
    ValueEdit,
    ColorSelector,
    DropdownList,
    FontSelector,
    AdjustedBalloon,

    ArrowDown,
    ArrowRight,
    CheckBoxOn,
    RadioOn,
    AlignLeftOn,
    AlignLeftOff,
    AlignCenterOn,
    AlignCenterOff,
    AlignRightOn,
    AlignRightOff,
    AlignTopOn,
    AlignTopOff,
    AlignMiddleOn,
    AlignMiddleOff,
    AlignBottomOn,
    AlignBottomOff
  }
})

export default class CalendarDayStyle extends Vue
{
    @Prop() private layer!: CalendarLayer;

    private changeInputMode(mode)
    {
        this.$store.dispatch("changeInputMode", mode);
    }

    private onChangingValue(value, tag)
    {
        this.changeLayerProperty(value, tag, false);
    }
    private onChangedValue(value, tag)
    {
        this.changeLayerProperty(value, tag, true);
    }

    private onChangingColor(color, tag)
    {
        this.changeLayerProperty(color, tag, false);
    }

    private onChangedColor(color, tag)
    {
        this.changeLayerProperty(color, tag, true);
    }

    // フォント
    private isFontDropdownActive : boolean = false;
    private dropdownListVisibleChanged(isVisible : boolean)
    {
        this.isFontDropdownActive = isVisible;
    }
    private get selectedFontId() { return this.layer.dayFontId; }
    private getFontManager() : FontManager { return this.$store.getters.fontManager; }
    private onSelectFont(fontId : string)
    {
        this.changeLayerProperty(fontId, "dayFontId", true, true);
    }

    // 開閉のアニメーション
    // TODO Props
    openStatus = {
        opend: true
    };

    calendarDayTransformContentsOpenAnimate = false;
    calendarDayTransformContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
        this.calendarDayTransformContentsCloseAnimate = true;
        setTimeout(() => {
            this.calendarDayTransformContentsCloseAnimate = false;
            this.calendarDayTransformContentsOpenAnimate = false;
            this.openStatus.opend = false;
        }, 200);
        } else {
        this.openStatus.opend = true;
        this.calendarDayTransformContentsOpenAnimate = true;
        setTimeout(() => {
            this.calendarDayTransformContentsOpenAnimate = false;
        }, 250);
        }
    }

    // カラーピッカー表示非表示
    isWeekDaysColorPickerVisible = false;
    showWeekDaysColorPicker() {
        this.isWeekDaysColorPickerVisible = true;
    }
    closeWeekDaysColorPicker() {
        this.isWeekDaysColorPickerVisible = false;
    }

    isSaturdayColorPickerVisible = false;
    showSaturdayColorPicker() {
        this.isSaturdayColorPickerVisible = true;
    }
    closeSaturdayColorPicker() {
        this.isSaturdayColorPickerVisible = false;
    }

    isSundayColorPickerVisible = false;
    showSundayColorPicker() {
        this.isSundayColorPickerVisible = true;
    }
    closeSundayColorPicker() {
        this.isSundayColorPickerVisible = false;
    }

    private changeLayerProperty(value : any, propertyName : string, isFinish : boolean = false, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", {
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }

    private get calendarDayTransformOpendStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0 && this.openStatus.opend){
            style = {
                height: "calc(412% / 752 * 100) !important"
            };
        }
        return style;
    }

    private get commonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "11.7%"
            };
        }
        return style;
    }

    private get buttonGroupStyle(){
        var style = {};
        if(this.applicationState.flowMode != 0){
            style = {
                height: "13.14%"
            };
        }
        return style;
    }

    private get applicationState(){
        return this.$store.getters.applicationState;
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
    
    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

}
